import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import type { Kategorie, Sezona, Stav } from '@/modules/uskladneni/api';

const UskladneniList = lazy(() =>
  import('@/modules/uskladneni/UskladneniList').then((m) => ({ default: m.UskladneniList })),
);

interface UskladneniSearch {
  kategorie?: Kategorie | 'all';
  sezona?: Sezona | 'all';
  stav?: Stav | 'all';
  lokace?: number;
}

const KATEGORIE_VALUES = ['klient', 'sklad', 'volne', 'all'] as const;
const SEZONA_VALUES = ['L', 'Z', 'ALL', 'all'] as const;
const STAV_VALUES = [
  'aktivni',
  'vraceno_klientovi',
  'vyrazeno',
  'prodano',
  'zruseno',
  'all',
] as const;

function parseUskladneniSearch(
  input: Record<string, unknown>,
): UskladneniSearch {
  const out: UskladneniSearch = {};
  const k = input.kategorie;
  if (typeof k === 'string' && (KATEGORIE_VALUES as readonly string[]).includes(k)) {
    out.kategorie = k as UskladneniSearch['kategorie'];
  }
  const s = input.sezona;
  if (typeof s === 'string' && (SEZONA_VALUES as readonly string[]).includes(s)) {
    out.sezona = s as UskladneniSearch['sezona'];
  }
  const st = input.stav;
  if (typeof st === 'string' && (STAV_VALUES as readonly string[]).includes(st)) {
    out.stav = st as UskladneniSearch['stav'];
  }
  const l = input.lokace;
  if (typeof l === 'number' && Number.isFinite(l) && l > 0) {
    out.lokace = l;
  } else if (typeof l === 'string' && /^\d+$/.test(l)) {
    out.lokace = Number(l);
  }
  return out;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/servis/uskladneni',
  component: () => (
    <Suspense fallback={null}>
      <UskladneniList />
    </Suspense>
  ),
  validateSearch: parseUskladneniSearch,
});
